<div class="content-container">
	<div class="header">
		<div class="heading">
			<img src="assets/PlowOpsPortal_Logo.svg"
				 alt="PlowOps Logo">

			<img src="assets/Route_Builder.svg"
				 class="ml-10"
				 alt="Route Builder">
		</div>
		<div class="right-content">
			<button mat-icon-button
					color="heavy"
					[routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_ROUTES]"
				aria-label="close">
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
	<div class="content">
		<div class="wizard-column">
			@if(wizard.loadingData | async) {
				<div class="p-15">
					<div class="text-muted">
						Processing Route Configuration Data
					</div>
					<mat-spinner diameter="30" class="mx-a mt-15">
					</mat-spinner>
				</div>
			}
			<mat-vertical-stepper [linear]="true" #stepper class="stepper"
								  [ngStyle]="{display: ((wizard.loadingData | async) ? 'none': 'inherit')}"
								  (selectionChange)="onStepperSelectionChange($event)">
				<mat-step [completed]="wizard.hasDataForStep1()">
					<div *matStepLabel>Data Source</div>

          <mat-form-field class="w-100 pt-10">
            <mat-label>
              Source Type
            </mat-label>
            <mat-select [(ngModel)]="wizard.dataSourceType"
            >
              <mat-option [value]="RouteSourceType.SHAPE_FILE">Shape File</mat-option>
              <mat-option [value]="RouteSourceType.ARCGIS_SERVICE">Online Service</mat-option>
            </mat-select>
          </mat-form-field>

          @if (wizard.dataSourceType === RouteSourceType.SHAPE_FILE) {
            <input hidden
                   type="file"
                   id="file"
                   accept=".zip, .shp"
                   #fileInput
                   (change)="step1LoadShapeFile($event)">

            <button mat-stroked-button
                    color="accent"
                    (click)="fileInput.click()"
            >
              Choose SHP (ZIP) file
            </button>

            <div>
              @if (wizard.layerLoadingError) {
                <mat-error class="mb-8">Error while loading data: {{ wizard.layerLoadingError }}</mat-error>
              }
              @if (wizard.loadingLayers | async) {
                <div class="text-muted">Converting data to geojson format...</div>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              }
            </div>
          }

          @if (wizard.dataSourceType === RouteSourceType.ARCGIS_SERVICE) {
            <form [formGroup]="dataSourceFormGroup" class="pt-10">
              <mat-form-field class="w-100">
                <mat-label>Server URL</mat-label>
                <input matInput
                     formControlName="serverUrl"
                     required
                     autocomplete="off">
              </mat-form-field>

              <mat-checkbox formControlName="useCredentials"
                            class="mb-8"
              >
                Use credentials for the server
              </mat-checkbox>

              @if (dataSourceFormGroup.get('useCredentials')?.value) {
                <mat-form-field class="w-100">
                  <mat-label>Username</mat-label>
                  <input matInput
                       formControlName="username"
                       autocomplete="off">
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Password</mat-label>
                  <input matInput
                       type="password"
                       formControlName="password"
                       autocomplete="new-password">
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>
                    Generate Token Client
                  </mat-label>
                  <mat-select formControlName="generateTokenClient"
                  >
                    <mat-option [value]="GenerateTokenClient.REQUESTIP">Request IP</mat-option>
                    <mat-option [value]="GenerateTokenClient.REFERER">HTTP Referer</mat-option>
                  </mat-select>
                </mat-form-field>
              }

              <div>
                @if (wizard.layerLoadingError) {
                  <mat-error class="mb-8">Error while loading data: {{ wizard.layerLoadingError }}</mat-error>
                }
                @if (wizard.loadingLayers | async) {
                  <div class="text-muted">Connecting to the server</div>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                } @else {
                  <button mat-stroked-button
                      type="submit"
                      [disabled]="dataSourceFormGroup.invalid"
                      (click)="step1LoadLayers()">
                    Connect To The Map Server
                  </button>
                }
              </div>
            </form>
          }
				</mat-step>

				<mat-step [completed]="wizard.hasDataForStep2()">
					<div *matStepLabel>Layer And Route Name Attribute</div>

          <div class="pt-10">
            @if (wizard.dataSourceType === RouteSourceType.SHAPE_FILE) {
              <mat-form-field class="w-100">
                <mat-label>
                  Route Name Attribute
                </mat-label>
                <mat-select [(ngModel)]="wizard.nameField"
                            (ngModelChange)="step1NameFieldChanged()"
                            [disabled]="isExistingAndShapeUploaded()"
                            required>
                  @for (field of wizard.fields; track $index) {
                    <mat-option [value]="field.name">{{ field.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (wizard.loadingFeatureCollection | async) {
                <div class="text-muted">Loading Routes</div>
                <mat-progress-bar mode="indeterminate"
                                  class="mb-10">
                </mat-progress-bar>
              }

              @if (wizard.featureCollectionLoadingError) {
                <p class="ui-error">{{ wizard.featureCollectionLoadingError }}</p>
              }

              <button mat-stroked-button
                      [disabled]="(wizard.loadingFeatureCollection | async) || !wizard.nameField"
                      (click)="step1LoadRoutes()">
                Get Routes
              </button>
            }

            @if (wizard.dataSourceType === RouteSourceType.ARCGIS_SERVICE) {
              <mat-form-field class="w-100">
                <mat-label>
                  Route Layer
                </mat-label>
                <mat-select [(ngModel)]="wizard.selectedLayerId"
                      (ngModelChange)="step2SelectedLayerChanged()"
                      [disabled]="wizard.loadingFields | async"
                      required>
                  @for (layer of wizard.layers; track $index) {
                    <mat-option [value]="layer.id">{{ layer.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (wizard.fields) {
                <mat-form-field class="w-100">
                  <mat-label>
                    Route Name Attribute
                  </mat-label>
                  <mat-select [(ngModel)]="wizard.nameField"
                        (ngModelChange)="step1NameFieldChanged()"
                        required>
                    @for (field of wizard.fields; track $index) {
                      <mat-option [value]="field.name">{{ field.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }

              @if ((wizard.loadingFields | async) || (wizard.loadingFeatureCollection | async)) {
                @if (wizard.loadingFields | async) {
                  <div class="text-muted">Loading Fields In Layer</div>
                } @else {
                  <div class="text-muted">Loading Routes</div>
                }
                <mat-progress-bar mode="indeterminate"
                          class="mb-10">
                </mat-progress-bar>
              }

              @if (wizard.fieldsLoadingError || wizard.featureCollectionLoadingError) {
                <p class="ui-error">{{ wizard.fieldsLoadingError || wizard.featureCollectionLoadingError }}</p>
              }

              <button mat-stroked-button
                  [disabled]="(wizard.loadingFeatureCollection | async) || !wizard.nameField"
                  (click)="step1LoadRoutes()">
                Get Routes
              </button>
            }
          </div>
        </mat-step>
				<mat-step [completed]="wizard.configurationWithSchema">
					<div *matStepLabel>Route Selection And Grouping</div>

					<ng-template [ngTemplateOutlet]="step2"></ng-template>
				</mat-step>
				<mat-step [completed]="wizard.configurationWithSchema">
					<div *matStepLabel>Route Presentation</div>

					<ng-template *ngTemplateOutlet="step3"></ng-template>
				</mat-step>
				<mat-step [formGroup]="routeConfigurationSettingsFormGroup"
						  class="pt-10">
					<div *matStepLabel>Route Configuration Settings</div>

					<form [formGroup]="routeConfigurationSettingsFormGroup">
            <div class="mt-15">
              <mat-form-field class="w-100" appearance="outline" color="accent">
                <mat-label>Configuration Name</mat-label>
                <input matInput
                       formControlName="configurationName"
                       required>
              </mat-form-field>

              <mat-checkbox formControlName="keepUpToDate">
                Keep Up To Date
              </mat-checkbox>

              <mat-checkbox formControlName="exportToCustomMapLayers">
                Export To Custom Map Layers
              </mat-checkbox>
            </div>

            <div class="pt-10 buttons">
              @if(wizard.routeConfigurationId) {
                <button mat-stroked-button
                        (click)="deleteRouteConfiguration()">
                  Delete Route Configuration
                </button>

                @if (wizard.showUpdateNote) {
                  <div>
                    Describe what changed in this Route Configuration (optional)
                  </div>
                  <mat-form-field class="w-100" subscriptSizing="dynamic">
                  <textarea matInput
                            autocomplete="off"
                            formControlName="updateNote"
                            cdkTextareaAutosize
                            cdkAutosizeMaxRows="12"
                            cdkAutosizeMinRows="5"
                  >
                  </textarea>
                  </mat-form-field>
                }

                <button mat-stroked-button
                        [disabled]="routeConfigurationSettingsFormGroup.invalid || (wizard.savingData | async)"
                        (click)="saveChanges()">
                  <div class="flex-row align-items-center">
                    Update Route Configuration
                    @if (wizard.savingData | async) {
                      <mat-spinner [diameter]="15"></mat-spinner>
                    }
                  </div>
                </button>
              } @else {
                <button mat-stroked-button
                        [disabled]="routeConfigurationSettingsFormGroup.invalid || (wizard.savingData | async)"
                        (click)="saveChanges()">
                  <div class="flex-row align-items-center">
                    Create Route Configuration
                    @if (wizard.savingData | async) {
                      <mat-spinner [diameter]="15"></mat-spinner>
                    }
                  </div>
                </button>
              }
            </div>
					</form>
				</mat-step>
			</mat-vertical-stepper>
		</div>
		<div class="map-container">
			<app-map-preview
					[nextContent]="mapContent"
					[mapTitle]="'Route Configuration Map'"
			></app-map-preview>
		</div>
	</div>
</div>

<ng-template #step2>
	@if(wizard.categories.length) {
		<div class="categories-title">Grouped by</div>
		@for(category of wizard.categories; track category) {
			<div class="category">
				<div class="name">{{category}}</div>
				<button mat-icon-button class="actions"
						[disabled]="isExistingAndShapeUploaded() || (wizard.loadingFeatureCollection | async)"
						matTooltip="Remove the group"
						(click)="removeCategory(category)">
					<mat-icon>delete</mat-icon>
				</button>
			</div>
		}
	} @else {
		<div class="pt-10"></div>
	}

	@if (wizard.loadingFeatureCollection | async) {
		<div class="text-muted">Loading Routes</div>
		<mat-progress-bar mode="indeterminate"></mat-progress-bar>
	} @else {
		<mat-form-field class="w-100" appearance="outline" color="accent">
			<mat-label>Select Attribute to Group By</mat-label>
			<mat-select (selectionChange)="onCategorySelected($event)"
						[disabled]="isExistingAndShapeUploaded() || (wizard.loadingFeatureCollection | async)"
						matTooltip="Choose field to group routes by"
						[(value)]="groupBeingAdded">
				@for(field of wizard.fields; track field) {
					<mat-option [value]="field.name">{{ field.name }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<app-route-tree
				[routeConfiguration]="wizard.routeConfiguration"
				[attributes]="wizard.attributes"
				[filteringMode]="true"
				(routeFiltered)="filterRoutes($event)"
				(styleChanged)="colorsOverrideChanged($event)"
				(routeHover)="onRouteHover($event)"
				(routeLeave)="onRouteLeave($event)">
		</app-route-tree>
	}

	<div class="pt-15">
		<button mat-stroked-button
				[disabled]="wizard.loadingFeatureCollection | async"
				(click)="nextStep()">
			Confirm Route Selection
		</button>
	</div>
</ng-template>

<ng-template #step3>

  <mat-form-field floatLabel="always" class="pt-15 w-100">
    <mat-label>Style Type</mat-label>
    <mat-select [(ngModel)]="wizard.stylePresentation"
                (ngModelChange)="stylePresentationChanged($event)"
    >
      @for (option of wizard.stylePresentationOptions; track option) {
        <mat-option [value]="option.value">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (wizard.stylePresentation === RoutePresentationStyle.SINGLE) {
    @if (wizard.loadingFeatureCollection | async) {
      <div class="text-muted">Loading Routes</div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else {
      <div class="flex-column">
        <div class="text-bolder">Style & Preview</div>
        <div class="flex-row justify-content-space-between align-items-center">
          <span>All Routes</span>
          @if (wizard.routeConfiguration) {
            <app-line-style-editor [routeStyle]="wizard.defaultRouteStyle"
                                   (routeStyleChanged)="defaultRouteStyleChanged($event)"
            >
            </app-line-style-editor>
          }
        </div>
      </div>
    }
  } @else if (wizard.stylePresentation === RoutePresentationStyle.ATTRIBUTE) {
    <mat-form-field class="w-100">
      <mat-label>Select Sub-Route Attribute</mat-label>
      <mat-select (selectionChange)="onSubRouteSelected()"
                  [disabled]="isExistingAndShapeUploaded() || (wizard.loadingFeatureCollection | async)"
                  matTooltip="Choose field to be able to style sub-routes"
                  [(value)]="subRouteBeingAdded"
      >
        <mat-option [value]="null">No Value</mat-option>
        @for(field of wizard.fields; track field) {
          <mat-option [value]="field.name">{{ field.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (wizard.subRouteAttribute) {
      @if (wizard.loadingFeatureCollection | async) {
        <div class="text-muted">Loading Routes</div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      } @else {
        <div class="flex-column">
          <div class="text-bolder">Style</div>
          @for (subRouteItem of wizard.routeConfiguration.subRouteItems; track $index) {
            <div class="flex-row justify-content-space-between align-items-center">
              <span>{{ subRouteItem.value }}</span>
              <app-line-style-editor [routeStyle]="subRouteItem.style"
                                     (routeStyleChanged)="subRouteStyleChanged(subRouteItem.value, $event)">
              </app-line-style-editor>
            </div>
          }
        </div>
        <div class="flex-column">
          <div class="text-bolder">Preview</div>
          <app-route-tree
            [routeConfiguration]="wizard.routeConfiguration"
            [attributes]="wizard.attributes"
            [filteringMode]="false"
            [readonlyPreviewMode]="true"
            [defaultStyle]="DEFAULT_ROUTE_STYLE"
            (styleChanged)="colorsOverrideChanged($event)"
            (routeHover)="onRouteHover($event)"
            (routeLeave)="onRouteLeave($event)">
          </app-route-tree>
        </div>
      }
    } @else {
      <p>
        You must select sub-route attribute.
      </p>
    }
  } @else {
    @if (wizard.loadingFeatureCollection | async) {
      <div class="text-muted">Loading Routes</div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else {
      <app-route-tree
        [routeConfiguration]="wizard.routeConfiguration"
        [attributes]="wizard.attributes"
        [filteringMode]="false"
        [readonlyPreviewMode]="false"
        [defaultStyle]="DEFAULT_ROUTE_STYLE"
        (styleChanged)="colorsOverrideChanged($event)"
        (routeHover)="onRouteHover($event)"
        (routeLeave)="onRouteLeave($event)">
      </app-route-tree>
    }
  }

	<div class="pt-15">
		<button mat-stroked-button
            [disabled]="(wizard.stylePresentation === RoutePresentationStyle.ATTRIBUTE && !wizard.subRouteAttribute) || (wizard.loadingFeatureCollection | async)"
				    (click)="nextStep()">
			Confirm Route Presentation
		</button>
	</div>
</ng-template>
